var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58463 10.854L2.25 9.43313H5.14969L5.43656 8.05894L8.01169 8.06063L8.65406 4.5H11.2449C12.9988 4.5 13.7098 5.20594 13.4471 6.66281L13.3909 6.975C13.2373 7.82381 12.8497 8.388 12.1838 8.71369C12.8436 9.05119 13.0652 9.68963 12.8993 10.6093L12.771 11.3214C12.5145 12.7423 11.4694 13.5 9.77175 13.5H7.02956L7.74 9.56644H6.87937L6.58463 10.854ZM9.43425 9.30881L8.90325 12.2507H9.99731C10.6464 12.2507 11.007 11.9627 11.1296 11.2832L11.2674 10.5221C11.4238 9.65419 11.1234 9.30881 10.2724 9.30881H9.43425ZM10.0772 5.74875L9.61369 8.316H10.4079C11.1324 8.316 11.556 8.00663 11.6859 7.28663L11.7743 6.7995C11.9008 6.09806 11.6387 5.74875 10.9744 5.74875H10.1813H10.0772Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurst);
export default __webpack_public_path__ + "static/media/burst.fc4dec5ca611a030901d6f6e21bd1f0c.svg";
export { ForwardRef as ReactComponent };